/**
 * Detect if area clicked is modal wrap
 * @param e
 */
export const isModalMaskClicked = (e: any): boolean =>
  Boolean(e && e.currentTarget && e.currentTarget.className.lastIndexOf('ant-modal-wrap') !== -1)
